// get_permission
export const GET_PERMISSION = 'get_permission';
export const GET_PERMISSION_SUCCESSFUL = 'get_permission_successfull';
export const GET_PERMISSION_FAILED = 'get_permission_failed';

// create_permission
export const CREATE_PERMISSION = 'create_permission';
export const CREATE_PERMISSION_SUCCESSFUL = 'create_permission_successfull';
export const CREATE_PERMISSION_FAILED = 'create_permission_failed';

// update_permission
export const UPDATE_PERMISSION = 'update_permission';
export const UPDATE_PERMISSION_SUCCESSFUL = 'update_permission_successfull';
export const UPDATE_PERMISSION_FAILED = 'update_permission_failed';

// delete_permission
export const DELETE_PERMISSION = 'delete_permission';
export const DELETE_PERMISSION_SUCCESSFUL = 'delete_permission_successfull';
export const DELETE_PERMISSION_FAILED = 'delete_permission_failed';
